<template>
  <div>
  <div class="wrapper" v-if="!isDes">
    <div class="user-block">
      <div class="user-info">
        <div class="div-block">
          您好
          <span class="name theme">{{userInfo.nickname}}</span>，欢迎进入会员中心
        </div>
        <div class="div-block jf">
          <div class="jf-l">
            当前积分
            <span class="level theme">{{userInfo.point}}</span>
<!--            <a
              href="javascript:;"
              class="sign"
              @click="sign"
              :class="isSign?'has':''"
            >{{isSign?'已签到':'签到'}}</a> -->
          </div>
        </div>
        <div class="div-block">
          余额：
          <span>￥{{userInfo.balance}}</span>
        <!--  <router-link :to="{name:'recharge'}" class="save">余额充值></router-link> -->
        </div>
      </div>
<!--      <div class="order-status">-->
<!--        <div>交易提醒:</div>-->
<!--        <div class="item" v-for="(item,index) in orderNumsArr" :key="index">-->
<!--          <router-link :to="{name:'myOrder',query:{type:index+1}}">-->
<!--            {{item.name}}-->
<!--            <span class="num" :class="item.value>0?'active':''">{{item.value}}</span>-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="order-wrap">
      <div class="order-head title">
        最近的订单
        <router-link :to="{name:'myOrder'}" class="btn">查看所有订单»</router-link>
      </div>
      <div class="order-list-wrap">
        <div class="order-head order-box" v-if="orderInfo.length==0" style="padding-left:30px;">暂无订单</div>
        <div class="order-head order-box" v-else>
          <div class="order-info">商品</div>
          <div class="order-price">单价</div>
          <div class="order-num">数量</div>
          <div class="order-total-price">总价</div>
          <div class="order-state">订单状态</div>
          <div class="order-handle">操作</div>
        </div>
        <div class="order-item" v-for="(order,index) in orderInfo" :key="index">
          <div class="order-item-head">
            <span class="time">{{orderTime(order.ctime)}}</span>
            订单号：
            <span class="code">{{order.order_id}}</span>
          </div>
          <div class="order-item-main order-box">
            <div class="order-info-list">
              <div class="order-li" v-for="(product,i) in order.items" :key="i">
                <img :src="product.image_url" alt class="order-img">
                <div class="order-name">{{product.name}}</div>
                <div class="order-price">￥{{product.price}}</div>
                <div class="order-num">
                  <i class="icon iconfont iconchenghao">{{product.nums}}</i>
                </div>
              </div>
            </div>
            <div class="order-total-price">￥{{order.order_amount}}</div>
            <div class="order-state">
              <div class="order-status">{{getOrderStatus(order)}}</div>
              <router-link
                :to="{name:'orderDetail',params:{order_id:order.order_id}}"
                class="order-detail-link"
                tag="a"
              >订单详情</router-link>
            </div>
            <div class="order-handle">
              <template v-if="order.status === 1 && order.pay_status === 1">
                <router-link :to="{name:'cashier',params:{order_id:order.order_id}}">立即支付</router-link>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 1"
              >
                <span @click="tackDelivery(order.order_id)">确认收货</span>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 2 && order.is_comment === 1"
              >
                <router-link :to="{name:'evaluate',query:{order_id:order.order_id}}">立即评价</router-link>
                <span v-if="order.wuliao_path" @click="customerService(order.order_id)">申请回收</span>
              </template>
              <template v-else>
                <span>
                  <router-link :to="{name:'detail',params:{goodsId:order.items[0].goods_id}}">再次购买</router-link>

                </span>
                <span v-if="order.wuliao_path" @click="customerService(order.order_id)">申请回收</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order-wrap">
      <div class="order-head title">
        最近收藏
        <router-link :to="'favourite'" class="btn">查看所有收藏»</router-link>
      </div>
      <div class="list">
        <div class="item" v-for="(item,index) in favList" :key="index">
          <div class="img-wrap">
            <img :src="item.goods.image_url" :alt="item.goods_name">
          </div>
          <div class="title">{{item.goods_name}}</div>
          <div class="price">{{item.goods.price}}元</div>
          <div class="actions">
            <a href="javascript:;" class="del" @click="delCollete(item.goods_id,index)">删除</a>
            <a href="javascript:;" class="detail" @click="lookDetail(item.goods_id)">查看详情</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="favList.length==0" style="padding-left:20px;color:#757575;font-size:12px;">暂无收藏</div>
  </div>
    <!--设计师页面-->
    <div v-else>
      <div class="user-block">
        <div class="user-info">
          <div class="div-block">
            您好
            <span class="name theme">{{userInfo.nickname}}</span>，欢迎进入设计师中心
          </div>
        </div>
        <div class="order-status">
          <div>设计订单提醒:</div>
          <div class="item" v-for="(item,index) in cusOrderNumsArr" :key="index">

              {{item.name}}
              <span class="num" :class="item.value>0?'active':''">{{item.value}}</span>

          </div>
        </div>
      </div>
      <div class="order-wrap">
        <div class="order-head title">
          定制订单
<!--          <router-link :to="{name:'myOrder',query:{order_type:9}}" class="btn">查看所有订单»</router-link>-->
        </div>
        <div class="order-list-wrap">
          <div class="order-head order-box" v-if="orderInfo.length==0" style="padding-left:30px;">暂无定制订单</div>
          <div class="order-head order-box" v-else>
            <div class="order-info">商品</div>
            <div class="order-price">已付金额</div>
            <div class="order-num"></div>
            <div class="order-total-price">总价</div>
            <div class="order-state">订单状态</div>
            <div class="order-handle">操作</div>
          </div>
          <div class="order-item" v-for="(order,index) in orderInfo" :key="index">
            <div class="order-item-head">
              <span class="time">{{orderTime(order.ctime)}}</span>
              定制订单订单号：
              <span class="code">{{order.order_id}}</span>
            </div>
            <div class="order-item-main order-box">
              <div class="order-info-list">
                <div class="order-li" >
                  <div class="order-img"></div>
                  <div class="order-name">定制订单</div>
                  <div class="order-price">￥{{order.payed}}</div>
                </div>
              </div>
              <div class="order-total-price">￥{{order.order_amount}}</div>
              <div class="order-state">
                <div class="order-status">{{getCusOrderStatus(order)}}</div>
                <router-link
                        :to="{name:'cusOrderDetail',params:{order_id:order.order_id}}"
                        class="order-detail-link"
                        tag="a"
                >订单详情</router-link>
              </div>
              <div class="order-handle">



                <template v-if="order.customized_status==3">
                <span>
                  <router-link :to="{name:'uploadDesign',params:{order_id:order.order_id}}">上传方案</router-link>
                </span>
                </template>
                <template v-else>
                <span>
                  无操作
                </span>
                </template>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeToDate } from "@/utils";
export default {
  name: "User",
  components: {},
  props: {},
  data() {
    return {
      userInfo: {},
      isSign: false,
      isDes:false,//是否设计师
      orderNumsArr: [
        {
          name: "待付款订单",
          value: 0
        },
        {
          name: "待发货订单",
          value: 0
        },
        {
          name: "待收货订单",
          value: 0
        },
        {
          name: "待评价订单",
          value: 0
        }
      ],
      cusOrderNumsArr: [
        {
          name: "待设计订单",
          value: 0
        },
        {
          name: "设计完成订单",
          value: 0
        },

      ],
      orderInfo: [],
      favList: [],
      cus_Btn:"",
    };
  },
  watch: {},
  computed: {
    orderTime() {
      return time => {
        return timeToDate(time);
      };
    },
    //获取定制订单状态文字显示
    getCusOrderStatus() {
      return order => {
        let orderStatusName;
        console.log("getCusOrderStatusin",order.customized_status);
        switch (order.customized_status) {
          case 1:
            orderStatusName = "需求提交，保证金未支付";
            break;
          case 2:
            orderStatusName = "保证金已支付，待分配设计师";
            break;
          case 3:
            orderStatusName = "设计师已分配，方案制作中";
            break;
          case 4:
            orderStatusName = "定制方案已提交，待确认";
            break;
          case 5:
            orderStatusName = "方案已确认，首款待付";
            break;
          case 6:
            orderStatusName = "首款已支付，制作中";
            break;
          case 7:
            orderStatusName = "制作完成，尾款待支付";
            break;
          case 8:
            orderStatusName = "已付清，待发货";
            break;
          case 9:
            orderStatusName = "已发货，待收货";
            break;
          case 10:
            orderStatusName = "已收货，定制订单完成";
            break;
        }
        return orderStatusName;
      };
    },

    //获取订单状态文字显示
    getOrderStatus() {
      return order => {
        let orderStatusName;
        switch (order.customized_status) {
          case 1:
            if (order.pay_status === 1) {
              orderStatusName = "待付款";
            }
            if (order.pay_status === 2 && order.ship_status === 1) {
              orderStatusName = "待发货";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 1
            ) {
              orderStatusName = "待收货";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 1
            ) {
              orderStatusName = "待评价";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 2
            ) {
              orderStatusName = "已评价";
            }
            if (order.pay_status === 4) {
              orderStatusName = "售后单";
            }
            break;
          case 2:
            orderStatusName = "已完成";
            break;
          case 3:
            orderStatusName = "已取消";
            break;
        }
        return orderStatusName;
      };
    }
  },
  methods: {
    //申请售后
    customerService(id) {
      this.$router.push({ name: 'currefundApply', params: { order_id: id } })
    },
    getLatestOrder() {
      //最近一个订单
      let data;
      if(this.isDes){
        data = {
          page: 1,
          limit: 100,
          status: 0,
          order_type:9,
        };
      }else{
        data = {
          page: 1,
          limit: 1,
          status: 0,
        };
      }

      this.$api.orderList(data).then(res => {
        if (res.status) {
          this.orderInfo = res.data.list;
        }
      });
    },
    getFavList() {
      let data = {
        page: 1,
        limit: 4
      };
      this.$api.goodsCollectionList(data).then(res => {
        if (res.status) {
          this.favList = res.data.list;
        }
      });
    },
    getOrderNums() {
      this.$api.getOrderStatusSum().then(res => {
        if (res.status) {
          let data = res.data;
          this.orderNumsArr.forEach((item, index) => {
            item.value = data[index + 1];
          });
          this.cusOrderNumsArr.forEach((item, index) => {
            item.value = data[index + 3];
          });
        }
      });
    },
    getUserInfo() {
      this.$api.userInfo().then(result => {
        if (result.status) {
          this.$storage.set("userInfo", result.data);
          this.userInfo = result.data;
          this.isDes=(result.data.type==2);
          this.getLatestOrder();
        }
      });
    },
    checkIsSign() {
      this.$api.isSign().then(res => {
        if (res.status) {
          this.isSign = true;
        }
      });
    },
    sign() {
      if (this.isSign) return;
      this.$api.sign().then(res => {
        if (res.status) {
          this.isSign = true;
          this.getUserInfo();
        }
      });
    },
    delCollete(id, index) {
      let data = {
        goods_id: id
      };
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.$msg(res.msg);
          this.$nextTick(() => {
            this.favList.splice(index, 1);
          });
        }
      });
    },
    lookDetail(id) {
      this.$router.push({ name: "detail", params: { goodsId: id } });
    }
  },
  created() {
  },
  mounted() {
    this.getUserInfo();
    this.checkIsSign();
    this.getOrderNums();
    this.getLatestOrder();
    this.getFavList();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
@import "./Favourite.scss";
.wrapper {
  .user-block {
    border: 1px solid $border;
    margin-bottom: 15px;
    .user-info {
      padding: 20px;
      .div-block {
        line-height: 30px;
        &.jf {
          display: flex;
          .jf-l {
            margin-right: 100px;
          }
        }
        span.theme {
          color: $theme-color;
        }
        span.level {
          margin: 0 5px;
        }
        .sign {
          display: inline-block;
          margin-left: 15px;
          width: 60px;
          height: 24px;
          line-height: 24px;
          color: #fff;
          background: $theme-color;
          text-align: center;
          &.has {
            background: #b0b0b0;
            cursor: no-drop;
          }
        }
        .save {
          margin-left: 20px;
          color: #757575;
          &:hover {
            color: $theme-color;
          }
        }
      }
    }
    .order-status {
      height: 45px;
      display: flex;
      align-items: center;
      border-top: 1px solid $border;
      padding: 0 20px;
      .item {
        padding-left: 20px;
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
        .num {
          display: inline-block;
          width: 18px;
          height: 18px;
          line-height: 18px;
          border-radius: 2px;
          background: #b0b0b0;
          text-align: center;
          color: #fff;
          &.active {
            background: $theme-color;
          }
        }
      }
    }
  }
  .order-wrap {
    border: 1px solid $border;
    margin-bottom: 15px;
    .order-head {
      height: 40px;
      line-height: 40px;
      background: #fff;
      color: #757575;
      box-sizing: border-box;
      &.title {
        text-indent: 20px;
      }
      .btn {
        margin-right: 30px;
        float: right;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
}
.order-item {
  box-sizing: border-box;

  .order-item-head {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #757575;
    padding-left: 20px;
    border-bottom: 1px solid $border;
    border-top: 1px solid $border;
    .time {
      margin-right: 30px;
    }
  }
}
.order-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  &.order-item-main {
    height: 100%;
    .order-info-list {
      border-right: 1px solid $border;
      width: 500px;
      min-height: 100px;
      .order-li {
        display: flex;
        align-items: center;
        &:not(:last-of-type) {
          border-bottom: 1px solid $border;
        }
        .order-img {
          display: block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }
        .order-name {
          width: 200px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
  &.order-head {
    @include line-height(40px);
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
    // margin: 20px 0;
  }
  .order-info {
    width: 310px;
    text-indent: 20px;
  }
  .order-price {
    width: 100px;
    text-align: center;
  }
  .order-num {
    width: 90px;
    text-align: center;
    .icon {
      font-size: 12px;
    }
  }
  .order-total-price {
    width: 120px;
    text-align: center;
  }
  .order-state {
    width: 150px;
    text-align: center;
    .order-status {
      margin-bottom: 10px;
    }
    .order-detail-link {
      &:hover {
        color: $theme-color;
      }
    }
  }
  .order-handle {
    width: 150px;
    text-align: center;
    span,
    a {
      padding: 5px 0;
      cursor: pointer;
      &:hover {
        color: $theme-color;
      }
    }
  }
}
.like-list {
  display: flex;
  flex-flow: row wrap;
  padding-top: 15px;
  .like-item {
    text-align: center;
    margin-left: 20px;
    margin-bottom: 15px;
    a {
      display: block;
    }
    .like-img {
      width: 150px;
      height: 150px;
      border: 1px solid $border;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .title {
      height: 30px;
      line-height: 30px;
      &:hover {
        color: $theme-color;
      }
    }
    .price {
      color: $theme-color;
    }
  }
}
</style>